import { getQuery } from "../utils/helpers";
import { lang } from "./lang";

export const locale = getQuery().get("lang");
export const localeData = lang[locale === "en" ? locale : "ar"];
